import React from 'react';
import { translate } from 'react-i18next';

import Linkify from 'react-linkify';
import Avatar from '../../../common/Avatar';
import Button from '../../../common/Button';
import { Link } from 'react-router-dom';
import Modal from '../../../common/Modal';
import Edit from '../../../memos/Edit';
import * as Date from '../../../utils/date';
import SendThanks from '../../../memos/send-thanks/';

class ListItem extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      editShareMemoModalOpen: false,
    };
  }

  handleEditShareMemoModalOpen = () => {
    this.setState({ editShareMemoModalOpen: true });
  };
  handleEditShareMemoModalClose = () => {
    this.setState({ editShareMemoModalOpen: false });
  };

  renderUser = (user = {}, projectId) => (
    <Link
      key={user._id}
      to={`/users/${user._id}`}
      className="u-display-flex u-align-items-center u-justify-content-center"
    >
      <Avatar
        data-tip={user.name}
        data-offset="{'left': 5}"
        data-for={projectId + user._id}
        className="u-margin-right"
        src={user.getSmallAvatarUrl()}
        width="55"
        height="55"
      />
      <h4 className="u-margin-bottom-none">{user.name}</h4>
    </Link>
  );

  render() {
    const {
      memo,
      t,
      project,
      isCurrentlyLoggedInUserMemo,
      currentUserId,
    } = this.props;
    const { editShareMemoModalOpen } = this.state;

    return (
      <div className="o-layout__item u-margin-bottom">
        <div className="c-box c-box-primary">
          <div className="c-box-primary__box">
            <div className="c-box-primary__text display-linebreak">
              <div className="u-display-flex u-justify-content-between u-margin-bottom">
                <div>{this.renderUser(memo.user, memo.project)}</div>
                <div className="u-text-right u-font-small">
                  <p className="u-weight-normal u-margin-bottom-none">
                    {t('project.memo.titleDate')}
                  </p>

                  <p
                    className="u-opacity-half u-margin-bottom-none"
                    title={Date.getHumanizedDate(memo.createdAt)}
                  >
                    {/* TODO */}
                    {/* <Link to="" className="u-text-underline">
                      Нюзлетър #1
                    </Link>{' '} */}
                    {Date.getHumanizedRemainingTimeTo(memo.createdAt)}
                  </p>
                </div>
              </div>
              <div className="">
                <Linkify
                  properties={{
                    target: '_blank',
                    className: 'u-color-blue-violet',
                  }}
                >
                  <div className="u-display-flex u-align-items-center u-justify-content-between">
                    <blockquote className="u-margin-bottom-none u-font-italic">
                      {memo.content}
                    </blockquote>
                    <div>
                      {isCurrentlyLoggedInUserMemo && (
                        <Button
                          type="button"
                          styleType="edit-icon"
                          className="u-margin-left"
                          onClick={this.handleEditShareMemoModalOpen}
                        />
                      )}
                    </div>
                  </div>
                </Linkify>
                <SendThanks
                  currentUserId={currentUserId}
                  isCurrentlyLoggedInUserMemo={isCurrentlyLoggedInUserMemo}
                  projectId={project._id}
                  memo={memo}
                />
              </div>
            </div>
          </div>
        </div>

        <Modal
          isOpen={editShareMemoModalOpen}
          onRequestClose={this.handleEditShareMemoModalClose}
          title={t('project.memo.modalTitle')}
        >
          <Edit
            project={project}
            memo={memo}
            onSuccess={this.handleEditShareMemoModalClose}
          />
        </Modal>
      </div>
    );
  }
}

export default translate()(ListItem);



// WEBPACK FOOTER //
// ./src/projects/details/memos/ListItem.js